import Vue from 'vue'
import { InertiaApp } from '@inertiajs/inertia-vue'
import { Inertia } from '@inertiajs/inertia'
import Vuetify from 'vuetify/lib'
// import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import { InertiaProgress } from '@inertiajs/progress'
import Cart from './cart.js'
import {_} from './trans'
import Theme from './theme'
import headerBar from "./headerBar";
import VuexInit from './vuexInit'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill-better-table/dist/quill-better-table.css'
import smoothscroll from 'smoothscroll-polyfill';


smoothscroll.polyfill()

InertiaProgress.init()

// import 'grapesjs/dist/css/grapes.min.css';
// import grapesjs from 'grapesjs';

Vue.use(Vuetify)
Vue.use(InertiaApp)
Vue.prototype.$route = route
Vue.prototype.$axios = require('axios')
Vue.prototype.$cart = Cart
/**
 *
 * @type {{downloadFile(*, *): void, imgUrl(*, *): *, pad: (function(*, *): string), payState2Explain(*): (string), getDateFromObjId(*): string, recaptchaHandle(*), getIconByExt(*): ({color: string, icon: string})}}
 */
let _theme = new Theme(route)
Vue.prototype.$lib = {

    getDateFromObjId(objId) { //convert object id to date
        let timestamp = objId.substring(0,8)
        let date = new Date( parseInt( timestamp, 16 ) * 1000 )
        return `${date.getFullYear()}/${this.pad(date.getMonth()+1, 2)}/${this.pad(date.getDate(), 2)}`
            +` ${this.pad(date.getHours(), 2)}:${this.pad(date.getMinutes(), 2)}:${this.pad(date.getSeconds(), 2)}`
    },
    pad: function(str, len) { //补零
        str = '' + str;
        return str.length >= len ? str : new Array(len - str.length + 1).join("0") + str
    },
    getIconByExt(ext) {
        switch (ext) {
            case "jpg":
            case "jpeg":
            case "png":
                return {icon: 'far fa-file-image', color: 'black'}
            case "csv":
            case "xlsx":
                return {icon: 'far fa-file-excel', color: 'green'}
            case "doc":
            case "docx":
                return {icon: 'far fa-file-word', color: 'blue'}
            case "pdf":
                return {icon: 'far fa-file-pdf', color: 'red'}
            default:
                return {icon: 'fas fa-question-circle', color: 'orange'}
        }
    },
    downloadFile(prod_oid, save_filename) {
        window.open(route('resource.get', {
            prod_oid,
            save_filename,
        }))
    },
    imgUrl(prod_oid, save_filename) {
        return route('resource.get', {
            prod_oid,
            save_filename,
        }).url()
    },
    payState2Explain(payState) {
        switch (payState) {
            case "wait":
                return _("waitPay")
            case "paid":
                return _("paid")
            default:
                return ""
        }
    },
    /**
     *
     * @param form
     * @param {Function} fn (token) => {}
     */
    recaptchaHandle(form={} ,fn) {
        grecaptcha.ready(function() {
            let key = document.head.querySelector('meta[name="recaptcha-site-key"]');
            let enabled = document.head.querySelector('meta[name="recaptcha-enabled"]').content;
            if(parseInt(enabled) === 1) {
                grecaptcha.execute(key.content).then(function(token) {
                    fn(Object.assign(form, {
                        recpatchaV3Token: token,
                    }))
                })
            } else {
                fn(form)
            }
        })
    },
    _: _,
    theme: _theme,
    openImgWindow(url) {
        window.open(url)
    }
}

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    Vue.prototype.$axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

const app = document.getElementById('app')
let store = VuexInit(Vue, _theme)

Inertia.on('navigate', (event) => {
    store.commit('update:theme')
    store.commit('update:route')
    store.commit('update:header', event.detail.page.props)
})

Inertia.on('success', (event) => {
    store.commit('update:theme')
    store.commit('update:route')
    store.commit('update:header', event.detail.page.props)
})

let main = new Vue({
    store: store,
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default)
        },
        provide() {
            return {
                getDateFromObjId: this.getDateFromObjId,
                pad: this.pad,
            }
        },
    }),
    vuetify: new Vuetify({
        icons: {
            iconfont: 'fa',
        },
    })
}).$mount(app)
